export * from './mobx/utils_mobx';
export function addKeyToIdentifier({ type, id, key = 'id' }) {
    if (!type || !id) {
        console.error('EntityByIdentifier unvollständig', type, id, key);
    }
    return { type, id, key };
}
export function convertEntityIdentifierToStoreKey(entityIdentifier) {
    return `${entityIdentifier.type}_${entityIdentifier.id}`;
}
export function convertSerializedToStoreKey(entitySerialized) {
    return `${entitySerialized.type}_${entitySerialized.id}`;
}
export function getElementsByClassName(className) {
    return Array.prototype.slice.call(document.getElementsByClassName(className));
}
export function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
export const tokenSecret = 'jksd??AA!fhsdhf33';
export { editObservable } from './mobx/decorators/editable';
